import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import { ButtonIcon } from '@seiue/ui'
import { Avatar } from 'antd'
import React, { ReactNode } from 'react'
import styled from 'styled-components'

import { Reflection } from 'packages/sdks-next/growp'

import { getTheme } from '@/utils/theme'

/**
 * 选中的管理员头像列表
 *
 * @param param - 参数
 * @param param.adminIds - 管理员id列表
 * @param param.addAdministrator - 添加管理员
 * @param param.teachers - 在校教师列表
 * @param param.getRightExtra - 获取右侧额外组件
 * @returns React.ReactNode
 */
export const AvatarList: React.FC<{
  adminIds: number[]
  addAdministrator: () => void
  teachers: Reflection[]
  getRightExtra?: (reflection: Reflection) => ReactNode
}> = ({ adminIds, addAdministrator, teachers, getRightExtra }) => {
  const theme = getTheme()

  return (
    <Wrapper>
      {teachers?.map((t) => {
        if (adminIds.includes(t.id)) {
          return (
            <AvatarWrapper key={t.id}>
              <Avatar
                src={t.avatar}
                size={32}
                style={{
                  backgroundColor: theme.brand._1,
                }}
              >
                {t.name.slice(-2)}
              </Avatar>
              <div>{t.name}</div>
              {getRightExtra?.(t)}
            </AvatarWrapper>
          )
        }
        return null
      })}
      <ButtonIcon
        icon={faPlus}
        style={{
          width: '44px',
          height: '44px',
          backgroundColor: theme.background._3,
          borderRadius: '50%',
        }}
        onClick={() => addAdministrator()}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
`

const AvatarWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  border: 1px solid ${({ theme }) => theme.border.greyLight};
  padding: 6px;
  border-radius: 24px;
`
